import DataForm from '../../data/main/config/setup/form/forms'
import DataRand from '../../data/main/config/setup/rand/randArt'

import { getField, updateField } from 'vuex-map-fields'

const state = {
  randSides: DataForm.forms.rechteck.type[0].rand,
  selectedOesenArt: {
    oesenArt: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt,
    code: DataRand.randArt.saum.optionsOesenart[0].value.code,
    price: null,
    drehverschluss: DataRand.randArt.saum.optionsOesenart[0].value.drehverschluss
  },
  selectedDrehverschluss: {
    art: DataRand.randArt.saum.optionsDrehverschluss[1].value.art,
    code: DataRand.randArt.saum.optionsDrehverschluss[1].value.code,
    factor: null
  },
  selectedBreiteHohlsaum: {
    breite: DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.breite,
    code: DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.code,
    price: null
  },
  selectedKederGroesse: {
    art: DataRand.randArt.keder.optionsKederGroesse[0].value.art,
    code: DataRand.randArt.keder.optionsKederGroesse[0].value.code,
    price: null
  },
  selectedHohlschnitt: DataRand.randArt.hohlschnitt.optionsHohlschnitt[1].value,
  randDefault: true
}

const mutations = {
  'SET_RAND_SIDES' (state, sides) {
    state.randDefault = true
    state.randSides = sides
  },
  'CLEAR_RAND_SIDES' (state) {
    state.randDefault = true
    state.randSides.forEach(el => {
      el.type = DataRand.randArt.schnittkante.title
      el.oesenAnzahl = 0
      delete el.conf
      delete el.confCode
    })
    state.selectedOesenArt = {
      oesenArt: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt,
      code: DataRand.randArt.saum.optionsOesenart[0].value.code,
      price: DataRand.randArt.saum.optionsOesenart[0].value.price,
      drehverschluss: DataRand.randArt.saum.optionsOesenart[0].value.drehverschluss
    }
    state.selectedDrehverschluss = {
      art: DataRand.randArt.saum.optionsDrehverschluss[1].value.art,
      code: DataRand.randArt.saum.optionsDrehverschluss[1].value.code,
      factor: DataRand.randArt.saum.optionsDrehverschluss[1].value.factor
    }
    state.selectedBreiteHohlsaum = {
      breite: DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.breite,
      code: DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.code,
      price: DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.price
    }
    state.selectedKederGroesse = {
      art: DataRand.randArt.keder.optionsKederGroesse[0].value.art,
      code: DataRand.randArt.keder.optionsKederGroesse[0].value.code,
      price: DataRand.randArt.keder.optionsKederGroesse[0].value.price
    }
    state.selectedHohlschnitt = DataRand.randArt.hohlschnitt.optionsHohlschnitt[1].value
  },
  'CHANGE_OESENART' (state, oesenArt) {
    state.selectedDrehverschluss = {
      art: DataRand.randArt.saum.optionsDrehverschluss[1].value.art,
      code: DataRand.randArt.saum.optionsDrehverschluss[1].value.code,
      factor: DataRand.randArt.saum.optionsDrehverschluss[1].value.factor
    }
    state.randSides.filter(el => el.type.name === DataRand.randArt.saum.titleSaum.name).forEach(el => {
      el.conf.oesenArt = oesenArt.oesenArt
      el.confCode.oesenArt = oesenArt.code
      if (oesenArt.oesenArt === DataRand.randArt.saum.optionsOesenart[0].value.oesenArt) {
        delete el.conf.oesenAnzahl
        delete el.conf.drehverschluss
        delete el.confCode.oesenAnzahl
        delete el.confCode.drehverschluss
      } else {
        el.conf.oesenAnzahl = el.oesenAnzahl
        el.confCode.oesenAnzahl = el.oesenAnzahl
        delete el.conf.drehverschluss
        delete el.confCode.drehverschluss
        if (oesenArt.drehverschluss) {
          el.conf.drehverschluss = state.selectedDrehverschluss.art
          el.confCode.drehverschluss = state.selectedDrehverschluss.code
        }
      }
    })
  },
  'CHANGE_OESENANZAHL' (state, config) {
    state.randSides[config.id].conf.oesenAnzahl = config.oesenAnzahl
    state.randSides[config.id].confCode.oesenAnzahl = config.oesenAnzahl
  },
  'CHANGE_DREHVERSCHLUSS' (state, drehverschluss) {
    state.randSides.filter(el => el.type.name === DataRand.randArt.saum.titleSaum.name).forEach(el => {
      el.conf.drehverschluss = drehverschluss.art
      el.confCode.drehverschluss = drehverschluss.code
    })
  },
  'CHANGE_BREITE_HOHLSAUM' (state, breiteHohlsaum) {
    state.randSides.filter(el => el.type.name === DataRand.randArt.hohlsaum.title.name).forEach(el => {
      el.conf.breiteHohlsaum = breiteHohlsaum.breite
      el.confCode.breiteHohlsaum = breiteHohlsaum.code
    })
  },
  'CHANGE_KEDER_GROESSE' (state, kederGroesse) {
    state.randSides.filter(el => el.type.name === DataRand.randArt.keder.title.name).forEach(el => {
      el.conf.kederGroesse = kederGroesse.art
      el.confCode.kederGroesse = kederGroesse.code
    })
  },
  'SET_RAND_SAUM' (state, config) {
    state.randDefault = false
    if (config.oesen.oesenArt === DataRand.randArt.saum.optionsOesenart[0].value.oesenArt) {
      state.randSides[config.id].conf = {
        oesenArt: config.oesen.oesenArt
      }
      state.randSides[config.id].confCode = {
        oesenArt: config.oesen.code
      }
    } else {
      state.randSides[config.id].conf = {
        oesenArt: config.oesen.oesenArt,
        oesenAnzahl: config.oesenAnzahl
      }
      state.randSides[config.id].confCode = {
        oesenArt: config.oesen.code,
        oesenAnzahl: config.oesenAnzahl
      }
      if (config.oesen.drehverschluss) {
        state.randSides[config.id].conf.drehverschluss = config.drehverschluss.art
        state.randSides[config.id].confCode.drehverschluss = config.drehverschluss.code
      }
    }
  },
  'SET_RAND_SCHNITTKANTE' (state, sideID) {
    delete state.randSides[sideID].conf
    delete state.randSides[sideID].confCode
  },
  'SET_RAND_HOHLSAUM' (state, config) {
    state.randDefault = false
    state.randSides[config.id].conf = {
      breiteHohlsaum: config.breiteHohlsaum.breite
    }
    state.randSides[config.id].confCode = {
      breiteHohlsaum: config.breiteHohlsaum.code
    }
  },
  'SET_RAND_KEDER' (state, config) {
    state.randDefault = false
    state.randSides[config.id].conf = {
      kederGroesse: config.kederGroesse.art
    }
    state.randSides[config.id].confCode = {
      kederGroesse: config.kederGroesse.code
    }
  },
  'SET_RAND_HOHLSCHNITT' (state) {
    state.randSides.forEach(el => {
      delete el.conf
      delete el.confCode
      el.type = DataRand.randArt.hohlschnitt.title
    })
  },
  'SET_RAND_INITIAL' (state) {
    state.selectedOesenArt.price = DataRand.randArt.saum.optionsOesenart[0].value.price
    state.selectedDrehverschluss.factor = DataRand.randArt.saum.optionsDrehverschluss[1].value.factor
    state.selectedBreiteHohlsaum.price = DataRand.randArt.hohlsaum.optionsBreiteHohlsaum[0].value.price
    state.selectedKederGroesse.price = DataRand.randArt.keder.optionsKederGroesse[0].value.price
  },
  updateField
}

const actions = {
  setRandSides: ({ commit }, sides) => {
    commit('SET_RAND_SIDES', sides)
    commit('CLEAR_RAND_SIDES')
  },
  clearRandSides: ({ commit }) => {
    commit('CLEAR_RAND_SIDES')
  },
  changeOesenArt: ({ commit }, oesenArt) => {
    commit('CHANGE_OESENART', oesenArt)
  },
  changeOesenAnzahl: ({ commit }, config) => {
    commit('CHANGE_OESENANZAHL', config)
  },
  changeDrehverschluss: ({ commit }, drehverschluss) => {
    commit('CHANGE_DREHVERSCHLUSS', drehverschluss)
  },
  changeBreiteHohlsaum: ({ commit }, breiteHohlsaum) => {
    commit('CHANGE_BREITE_HOHLSAUM', breiteHohlsaum)
  },
  changeKederGroesse: ({ commit }, kederGroesse) => {
    commit('CHANGE_KEDER_GROESSE', kederGroesse)
  },
  setRandSaum: ({ commit }, config) => {
    commit('SET_RAND_SAUM', config)
  },
  setRandSchnittkante: ({ commit }, sideID) => {
    commit('SET_RAND_SCHNITTKANTE', sideID)
  },
  setRandHohlsaum: ({ commit }, config) => {
    commit('SET_RAND_HOHLSAUM', config)
  },
  setRandKeder: ({ commit }, config) => {
    commit('SET_RAND_KEDER', config)
  },
  setRandHohlschnitt: ({ commit }) => {
    if (state.selectedHohlschnitt) {
      commit('SET_RAND_HOHLSCHNITT')
    } else {
      commit('CLEAR_RAND_SIDES')
    }
  },
  setRandInitial: ({ commit }) => {
    commit('SET_RAND_INITIAL')
  }
}

const getters = {
  randSides: state => {
    return state.randSides
  },
  activeSaum: state => {
    return state.randSides.some(el => {
      return el.type.name === DataRand.randArt.saum.titleSaum.name
    })
  },
  activeOesenArt: state => {
    return (state.selectedOesenArt.oesenArt !== DataRand.randArt.saum.optionsOesenart[0].value.oesenArt)
  },
  activeDrehverschluss: state => {
    return state.selectedDrehverschluss.factor !== 0
  },
  activeHohlsaum: state => {
    return state.randSides.some(el => {
      return el.type.name === DataRand.randArt.hohlsaum.title.name
    })
  },
  activeKeder: state => {
    return state.randSides.some(el => {
      return el.type.name === DataRand.randArt.keder.title.name
    })
  },
  activeHohlschnitt: state => {
    return state.selectedHohlschnitt
  },
  randDefault: state => {
    return state.randDefault
  },
  getField
}

export default {
  state,
  getters,
  mutations,
  actions
}
